module.exports = __webpack_public_path__ + "img/camp_shirt_gk10.f9b130a5.svg";